<template>
  <div class="container">
    <Breadcrumb :path="path"></Breadcrumb>

    <div class="tips">
      {{ tips }}
    </div>
    <!-- 表单 -->
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="主题" required prop="theme">
        <a-input v-model="form.theme" placeholder="请输入主题" />
      </a-form-model-item>
      <van-field name="radio" label="投诉类型" prop="SuggestedType">
        <template #input>
          <van-radio-group v-model="form.SuggestedType" direction="horizontal">
            <van-radio
              checked-color="#ee0a24"
              icon-size="22px"
              :name="item.id"
              v-for="(item, index) in typeList"
              :key="index"
              >{{ item.name }}</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="反馈方式" prop="FeedMode">
        <template #input>
          <van-radio-group v-model="form.FeedMode" direction="horizontal">
            <van-radio checked-color="#ee0a24" icon-size="22px" name="1"
              >实名</van-radio
            >
            <van-radio checked-color="#ee0a24" icon-size="22px" name="2"
              >匿名</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>
      <a-form-model-item
        label="申请人"
        required
        prop="applicant"
        v-if="form.FeedMode == 1"
      >
        <a-input v-model="form.applicant" disabled placeholder="请输入申请人" />
      </a-form-model-item>
      <a-form-model-item
        label="联系方式"
        required
        prop="ContactInfo"
        v-if="form.FeedMode == 1"
      >
        <a-input
          v-model="form.ContactInfo"
          disabled
          placeholder="请输入联系方式"
        />
      </a-form-model-item>
      <a-form-model-item label="投诉对象" required prop="ObjectComplaint">
        <a-input
          v-model="form.ObjectComplaint"
          type="textarea"
          style="resize: none; word-break: break-all"
          class="jysy"
        />
      </a-form-model-item>
      <a-form-model-item label="投诉事实陈述" required prop="ComplaintFact">
        <a-input
          v-model="form.ComplaintFact"
          type="textarea"
          style="resize: none; word-break: break-all"
          class="gsjy"
          placeholder="详细说明投诉事项"
        />
      </a-form-model-item>
      <div class="upload"><span>附件</span> 文件大小限制30M以内</div>
      <div class="fileUpload">
        <div class="fileUpload">
          <van-uploader
            :max-size="30000 * 1024"
            v-model="fileList"
            multiple
            :after-read="afterRead"
            upload-icon="plus"
            accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, image/jpeg, image/png, text/plain"
            @delete="deleteFile"
          />
        </div>
      </div>
      <a-form-model-item
        label="处理建议/期望"
        required
        prop="HandlingSuggestion"
      >
        <a-input
          v-model="form.HandlingSuggestion"
          type="textarea"
          style="resize: none; word-break: break-all"
          class="yqxg"
          placeholder="详细说明建议改善的具体办法、程序、步骤等"
        />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button type="primary" @click="onSubmit" :loading="btnLoading">
          提交
        </a-button>
        <a-button class="min767" style="margin-left: 10px" @click="Cancel">
          取消
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- 表单END -->

    <van-popup class="popup" v-model="show" :close-on-click-overlay="false">
      <img src="../../assets/img/success.png" alt="" />
      <div class="title">提交成功</div>
      <div class="titleInf">
        我们将尽快为您处理，结果将以短信通知您，请留意查看！
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  $add_complaint,
  $upload,
  $get_user_info,
  $data_type_des,
  $get_type,
} from "@/api/index.js";
import { Message } from "ant-design-vue";
import Breadcrumb from "../../components/Breadcrumb";
import lodash from "lodash";
export default {
  name: "complaint",
  components: {
    Breadcrumb,
  },
  data() {
    // 手机号验证规则
    let checkPhone = (rules, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        let phoneZZ =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!phoneZZ.test(value)) {
          callback(new Error("请输入正确的手机号格式"));
        } else {
          callback();
        }
      }
    };
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      loading: false,
      btnLoading: false,
      show: false,
      fileList: [],
      imageUrl: "",
      fileListData: [],
      tips: "",
      typeList: [],
      form: {
        theme: "", // 主题
        SuggestedType: "8", // 建议类型
        FeedMode: "1", // 反馈方式
        applicant: "", // 申请人
        ContactInfo: "", // 联系方式
        ObjectComplaint: "", // 投诉对象
        ComplaintFact: "", // 投诉事实
        HandlingSuggestion: "", // 处理建议
      },

      rules: {
        theme: [
          { required: true, message: "请输入主题", trigger: "change" },
          { min: 2, message: "内容不能低于2个字", trigger: "blur" },
        ],
        SuggestedType: [
          { required: true, message: "请选择建议类型", trigger: "change" },
        ],
        FeedMode: [
          { required: true, message: "请选择反馈方式", trigger: "change" },
        ],
        applicant: [
          { required: true, message: "请填写申请人", trigger: "change" },
        ],
        ContactInfo: [{ validator: checkPhone, trigger: "change" }],
        ObjectComplaint: [
          { required: true, message: "请填写投诉对象", trigger: "change" },
        ],
        ComplaintFact: [
          { required: true, message: "请填写投诉事实", trigger: "change" },
          { min: 10, message: "内容不能低于10个字", trigger: "blur" },
        ],
        HandlingSuggestion: [
          { required: true, message: "请填写处理建议", trigger: "change" },
          { min: 10, message: "内容不能低于10个字", trigger: "blur" },
        ],
      },
    };
  },
  // 计算属性
  computed: {
    path() {
      let arr = [
        { name: "首页", names: "Home" },
        { name: "投诉举报", names: "complaint" },
      ];
      return arr;
    },
  },
  async mounted() {
    try {
      let { data: userinfo } = await $get_user_info();
      this.form.applicant = userinfo.real_name;
      this.form.ContactInfo = userinfo.mobile;
    } catch (error) {}
    try {
      let res = await $data_type_des({ data_type: 2 });
      this.tips = res.data[0];
    } catch (error) {
      console.log(error);
    }

    try {
      let res = await $get_type({ data_type: 2 });
      console.log("get_type", res);
      this.typeList = res.data;
    } catch (error) {
      console.log(error);
    }
  },
  // 数据监听
  watch: {},

  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (file.length > 1) {
        file.forEach((item) => {
          let formData = new FormData();
          formData.append("file", item.file);
          $upload(formData)
            .then((res) => {
              this.fileListData.push({
                filename: item.file.name,
                path: res.data.image,
                file_type: item.file.type,
              });
            })
            .catch((err) => {
              console.log(err);
              // Message.error({ content: '文件上传失败' });
            });
        });
        console.log("this.fileListData", this.fileListData);
        return;
      }
      let formData = new FormData();
      formData.append("file", file.file);
      $upload(formData)
        .then((res) => {
          this.fileListData.push({
            filename: file.file.name,
            path: res.data.image,
            file_type: file.file.type,
          });
        })
        .catch((err) => {
          // Message.error({ content: '文件上传失败' });
        });
      console.log("this.fileListData", this.fileListData);
    },
    deleteFile(file, detail) {
      this.fileListData.splice(detail.index, 1);
    },
    // 提交按钮
    onSubmit: lodash.throttle(function () {
      this.$refs.form.validate(async (valid) => {
        console.log(this.btnLoading);
        if (valid) {
          this.btnLoading = true;
          try {
            let params = {
              title: this.form.theme,
              type: this.form.SuggestedType,
              feedback_type: this.form.FeedMode,
              real_name: this.form.applicant,
              mobile: this.form.ContactInfo,
              complaint_obj: this.form.ObjectComplaint,
              complaint_content: this.form.ComplaintFact,
              files: this.fileListData,
              for_complaint: this.form.HandlingSuggestion,
            };
            let res = await $add_complaint(params);
            setTimeout(() => {
              this.show = false;
              this.$router.push({ name: "feedback" });
              this.btnLoading = false;
            }, 3000);
            this.show = true;
            this.$refs.form.resetFields();
            this.form.SuggestedType = "";
            this.form.FeedMode = "";
            this.fileList = [];
          } catch (error) {
            Message.error(error.msg);
            console.log(error);
          } finally {
            // this.btnLoading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }, 60000),

    // 取消
    Cancel() {
      this.$router.back();
    },
    // 弹出层，返回首页
    backHome() {
      this.$router.push("/home");
      this.show = false;
    },
  },
};
</script>

<style scoped lang="less">
@media (min-width: 767px) {
  .container {
    max-width: 1280px;
    height: auto;
    background: #ffffff;
    margin: 16px auto;
    padding: 26px 86px;

    .tips {
      width: 100%;
      height: auto;
      background: #f5f5f5;
      margin-top: 23px;
      margin-bottom: 35px;
      padding: 23px 34px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    /deep/.ant-form-item {
      margin-bottom: 20px;
    }

    // 每一项表单标题
    /deep/.ant-form-item-required {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    /deep/.ant-input {
      font-size: 18px;
    }

    /deep/.van-field__label {
      position: relative;
      margin-left: -6px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    /deep/.van-field__label::before {
      content: "*";
      position: absolute;
      color: red;
      top: 0;
      left: -10px;
      font-family: SimSun, sans-serif;
      font-size: 14px;
    }

    /deep/.van-field__label::after {
      content: ":";
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 18px;
      font-family: PingFang SC;
    }

    /deep/.van-radio__label {
      font-size: 18px;
    }

    /deep/.van-cell {
      position: unset;
      padding-top: 0px;
      margin-bottom: 8px;
    }

    .jysy,
    .gsjy,
    .yqxg {
      height: 90px;
    }

    .upload {
      padding-left: 98px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;

      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-left: -43px;
        margin-right: 15px;
      }
    }

    /deep/.ant-col-4 {
      width: 98px;
      word-break: break-all;
      white-space: break-spaces;
    }

    /deep/.ant-col-14 {
      width: 89.333333%;
      margin-left: 10px;
    }

    // 文件上传

    .fileUpload {
      margin-left: 55px;
      margin-top: 6px;

      /deep/ .van-uploader__upload {
        background-color: #f6f6f6;
      }
    }
  }

  // 按钮

  /deep/.ant-btn {
    width: 122px;
    height: 49px;
    background: #e1e1e1;
    border-radius: 4px;

    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  /deep/.ant-btn-primary {
    margin-left: 107px;
    width: 122px;
    height: 49px;
    background: #e60012;
    border-radius: 4px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    border: none;
  }

  // 弹出层
  .popup {
    width: 472px;
    height: 301px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      margin: 13px 0 8px 0;
    }

    .titleInf {
      padding: 0 57px;
      font-size: 18px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
    }

    .cancel {
      width: 122px;
      height: 49px;
      background: #e60012;
      border-radius: 4px;
      line-height: 49px;
      text-align: center;
      color: #fff;
      margin-top: 33px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      cursor: pointer;
    }
  }
}

// H5样式

@media (max-width: 767px) {
  .container {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 16px;

    .tips {
      width: 100%;
      height: auto;
      background: #f5f5f5;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 17px;
      padding: 13px 20px 16px 16px;
      margin-bottom: 22px;
    }

    /deep/.ant-form-item-required {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333;
    }

    /deep/.ant-form-item-label {
      margin-bottom: 10px;
      padding: 0;
    }

    /deep/.ant-input {
      font-size: 18px;
      margin-right: 10px;
    }

    /deep/.van-field__label {
      position: relative;
      margin-left: 10px;
      margin-bottom: 10px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
    }

    .van-radio {
      margin-bottom: 15px;
    }

    /deep/.van-radio__label {
      font-size: 15px;
    }

    /deep/.van-radio--horizontal {
      margin-bottom: 10px;
    }

    /deep/.van-field__label::before {
      content: "*";
      position: absolute;
      color: red;
      top: 0;
      left: -10px;
      font-family: SimSun, sans-serif;
      font-weight: bold;
      font-size: 14px;
    }

    /deep/.van-cell {
      position: unset;
      padding-top: 0px;
      margin-bottom: 8px;
      display: block;
      padding: 10px 0;
    }

    .upload {
      // padding-left: 53px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;

      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
      }
    }

    /deep/.ant-col-4 {
      width: 40%;
    }

    /deep/.ant-col-14 {
      width: 100%;
    }

    // 文件上传

    .fileUpload {
      // margin-left: 95px;
      margin-top: 6px;

      /deep/ .van-uploader__upload {
        background-color: #f6f6f6;
      }
    }

    .avatar-uploader > .ant-upload {
      width: 128px;
      height: 128px;
    }

    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }

    /deep/.ant-upload.ant-upload-select-picture-card {
      border: none !important;
    }
  }

  .ant-input {
    height: 37px;
  }

  .jysy,
  .gsjy {
    height: 87px;
  }

  .yqxg {
    height: 104px;
  }

  // 按钮
  /deep/.ant-btn {
    width: 122px;
    height: 49px;
    background: #e1e1e1;
    border-radius: 4px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  /deep/.ant-btn-primary {
    width: 100%;
    height: 49px;
    background: #e60012;
    border-radius: 4px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    border: none;
  }

  /deep/.ant-col-offset-4 {
    margin-left: 0;
  }

  .min767 {
    display: none;
  }

  .popup {
    width: 339px;
    height: 274px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

    .title {
      font-size: 19px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
    }

    .titleInf {
      width: 278px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      text-align: center;
    }

    .cancel {
      width: 155px;
      height: 51px;
      line-height: 51px;
      text-align: center;
      background: #ea4949;
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
</style>
